import queryString from 'query-string';

import { getLoginUrl } from '../../helpers/authUrls';

export const SET_REDIRECT = 'SET_REDIRECT';

const setWindowLocation = (redirectUrl) => {
  window.location.href = redirectUrl;
};

const setRedirect = (value) => ({
  type: SET_REDIRECT,
  value,
});

const redirect = () => (dispatch, getState) => {
  const query = queryString.parse(window.location.search);
  const regex = /((.*)?(native-instruments\.(de|com))|test\.ni\.de)|(^\/.*)/i;

  const {
    login: { redirect: stateRedirect },
  } = getState();

  if (stateRedirect) {
    return setWindowLocation(stateRedirect);
  }

  if (query.redirect && regex.test(query.redirect)) {
    return setWindowLocation(query.redirect);
  }

  return setWindowLocation(
    `${window.location.origin}${window.location.pathname}`
  );
};

const redirectToRestrictedUrl = (url) => (dispatch, getState) => {
  const {
    login: { isLoggedIn },
  } = getState();

  dispatch(setRedirect(url));

  if (isLoggedIn) {
    dispatch(redirect());
  } else {
    setWindowLocation(getLoginUrl(url));
  }
};

export default redirect;

export { redirectToRestrictedUrl, setRedirect };
